<script lang="ts">import { onMount } from "svelte";
export let label = " ";
export let numInputs = 6;
export let handleOtpChange = (otpCode) => {
	console.log(`handleOtpChange not implemented [${otpCode}]`);
	return Promise.resolve(false);
};
let submitting = false;
let error = false;
let valid = undefined;
let fatalError = false;
let invalidCodes = [];
let inputs = [];
let otp = Array(numInputs).fill("");
const handleInput = (index, event) => {
	try {
		const input = event.target;
		const value = input.value.replace(/\D/g, "");
		if (value.length === 1) {
			otp[index] = value;
			if (index < numInputs - 1) {
				inputs[index + 1].focus();
			}
		} else {
			otp[index] = "";
		}
		input.value = value;
		handleOtpCheck();
	} catch (error) {
		console.warn("handleInput error:", error);
	}
};
const handleOtpCheck = async () => {
	try {
		const otpCode = otp.join("");
		if (otpCode.length === numInputs) {
			if (invalidCodes.includes(otpCode)) {
				valid = false;
				console.log(`already known to be invalid: ${otpCode}`);
				return;
			}
			if (handleOtpChange && typeof handleOtpChange === "function") {
				submitting = true;
				valid = await handleOtpChange(otpCode);
				submitting = false;
				if (valid === false) invalidCodes.push(otpCode);
				console.log(`input believes code is ${valid}`);
			} else {
				console.warn("handleOtpChange is not a function");
			}
		} else {
			valid = undefined;
			error = false;
		}
	} catch (error) {
		console.warn("handleOtpCheck error:", error);
	}
};
const handlePaste = (event) => {
	try {
		event.preventDefault();
		const paste = event.clipboardData?.getData("text") ?? "";
		const numericPaste = paste.replace(/\D/g, "");
		if (numericPaste.length > 0) {
			const pasteArray = numericPaste.split("").slice(0, numInputs);
			for (let i = 0; i < pasteArray.length && i < numInputs; i++) {
				otp[i] = pasteArray[i];
				inputs[i].value = pasteArray[i];
				if (inputs[i + 1]) {
					inputs[i + 1].focus();
				}
			}
			handleOtpCheck();
		}
	} catch (error) {
		console.warn("hadlePast error:", error);
	}
};
const handleKeyUp = (_index, event) => {
	if (event.key === "Backspace") {
		handleOtpCheck();
	}
};
const handleKeyDown = (index, event) => {
	if (event.key === "Backspace") {
		if (otp[index] === "" && index > 0) inputs[index - 1].focus();
	}
	// Check if Ctrl or Cmd is pressed along with 'V' for paste operations
	if (event.key === "v" && (event.ctrlKey || event.metaKey)) {} else if (!/^[0-9]$/.test(event.key) && event.key !== "Backspace") {
		event.preventDefault();
	} else {
		// Clear this and all subsequent inputs for input
		inputs.forEach((_, i) => {
			if (i >= index) {
				otp[i] = "";
				inputs[i].value = "";
			}
		});
	}
};
onMount(() => {
	inputs[0].focus();
});
</script>

<div class="otp-input-container">
	{#each Array(numInputs) as _, index}
		<input
			class="otp-input {valid === false ? 'error' : ''} {valid === true ? 'valid' : ''}"
			type="number"
			bind:this={inputs[index]}
			maxlength="1"
			on:input={(event) => handleInput(index, event)}
			on:keydown={(event) => handleKeyDown(index, event)}
			on:keyup={(event) => handleKeyUp(index, event)}
			on:paste={handlePaste}
			disabled={submitting || valid || fatalError}
		/>
	{/each}
</div>

<p class="message {valid === false || error === true ? 'error' : ''}">
	{valid === false ? '*The code is incorrect' : error && status ? status : label}<br />
</p>

<style>
	.otp-input-container {
		display: flex;
		justify-content: space-between;
		padding-bottom: 0.75rem;
}
	.otp-input {
		height: 4rem;
		width: 3.5rem;
		border-radius: 0.75rem;
		border-width: 2px;
		border-color: var(--color-neutral-900);
		background-color: transparent;
		text-align: center;
		font-size: 1.5rem;
		line-height: 2rem;
		outline: 2px solid transparent;
		outline-offset: 2px;
}
	.otp-input:focus {
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
		--tw-ring-color: var(--color-primary-500);
}
	.otp-input.error {
		--tw-border-opacity: 1;
		border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
	.otp-input.valid {
		border-color: var(--color-primary-500);
}
	.message {
		margin-top: 0.5rem;
		margin-bottom: 0.5rem;
		text-align: center;
		font-size: 0.875rem;
		line-height: 1.25rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.error {
		--tw-text-opacity: 1;
		color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
	/* Chrome, Safari, Edge, Opera */
	input[type='number']::-webkit-outer-spin-button,
	input[type='number']::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	/* Firefox */
	input[type='number'] {
		-moz-appearance: textfield;
	}
</style>
